import React from "react";

import Text from "/component/base/Text";
import SegmentedControl, { Props } from "/component/partial/SegmentedControl";
import { useDocumentsContext } from "/component/provider/DocumentsProvider/DocumentsProvider";
import useTranslation from "/hook/useTranslation/useTranslation";
import { layout } from "/styles";

import { BadgeContainer, SegmentedControlWrapper } from "./DocumentSegementedControl.styles";

type DocumentControlProps = Omit<Props<string>, "options">;

const DocumentSegmentedControl = ({ onItemSelected, value, ...props }: DocumentControlProps) => {
  const { t } = useTranslation("documents");
  const { loadingInOfficeDocs, loadingVideoDocs, inOfficeUnreadCount, videoUnreadCount } =
    useDocumentsContext();

  const UnreadBadge = ({ count }: { count: number }) => {
    if (loadingInOfficeDocs || loadingVideoDocs) return null;

    if (typeof count === "number" && count > 0) {
      return (
        <BadgeContainer>
          <Text css={{ alignSelf: "center", fontSize: 12 }} variant="body1Bold" color="white">
            {count > 99 ? "99" : count}
          </Text>
        </BadgeContainer>
      );
    }

    return null;
  };

  const menuItems = [
    {
      value: "inOffice",
      label: t("segmentedControl.inOffice"),
      endIcon: <UnreadBadge count={inOfficeUnreadCount} />,
    },
    {
      value: "video",
      label: t("segmentedControl.video"),
      endIcon: <UnreadBadge count={videoUnreadCount} />,
    },
  ];

  return (
    <SegmentedControlWrapper>
      <SegmentedControl
        css={layout.margin("expanded", "none", "none", "none")}
        {...props}
        onItemSelected={onItemSelected}
        options={menuItems}
        value={value}
      />
    </SegmentedControlWrapper>
  );
};

export default DocumentSegmentedControl;
